import React, { Component, } from 'react';
import { withRouter } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import Login from './Login';
import PasswordChanger from './PasswordChanger';
import PhotoChanger from './PhotoChanger';
import AppInstaller from '../../components/AppInstaller';
import Header from '../../components/Header';
import SideBar from '../../components/SideBar';
import Container from '../../components/Container';
import Footer from '../../components/Footer';
import FooterMenu from '../../components/FooterMenu';
import ContactUs from '../../components/contact-us';
import Faqs from '../../components/faqs';
import FaqsSwahili from '../../components/faqs_swahili';
import { BmiForm, GrowthChart } from '../../bmi';
import { Feeding, FeedingForm, SmartFeedingForm, ReactCalender } from '../../feeding';
import {Language, Translator, UserController} from '../';
import '../styles/Dashboard.css';
import firebase from '../../Firebase';
// import { userInfo } from 'os';

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logedin: false,
      checked: false,
      User: {},
      Child: {},
      age: {},
      lang: "sw",
      card: 'rch_card',
      showInfoBar: false,
      showFooterMenu: false,
      response: {
        success: false,
        error: null,
        loading: false
      },
      header: {
        showUserInfo: true,
        showBackButton: false,
        showLanguageSwitcher: true,
        showCardSwitcher: false,
        showTitle: true,
        showFeedingInst: true,
      },
      footer: {
        f_button: '',
        c_button: '',
        co_button: '',
        fa_button: ''
      },
    };
  }

   // Fetch stored user data
  getData = () => {
    
    const response = this.state.response;
    response.loading= true;
    this.setState({response: response});

    UserController.getData().then((res) => {
      if(res.success){
        const userInfo = res.data
        response.success = true;
        response.loading= false;
        this.setState({User: userInfo.user, Child: userInfo.child, age: userInfo.age, response: response, logedin: true, checked: true});

        UserController.getPhoto(userInfo.user).then((res) => {
          if(res.success){
           this.onUserPhotoChange(res.url);
          }
        }).catch((error) => {
            alert(error);
        });

      }
      else{
        response.success = false;
        response.loading= false;
        this.setState({response: response, checked: true});
        this.login();
      }
    }).catch((error) => {
        alert(error);
    });
    
  };
  //END Fetch stored user data

  onUserPhotoChange = (url) => {
    const User = this.state.User;
    User.photo = url;
    this.setState({ User });
  };

  onLanguageChange = (e) => {
    const lang_code = e.target.value;
    this.setState({ lang: lang_code });
  };

  onCardChange = (e) => {
    const card = e.target.value;
    this.setState({ card: card });
  };

  showSideBar = () => {
    this.setState({ showInfoBar: !this.state.showInfoBar});
  };

  showTitle = () => {
    const state = this.state;
    state.header.showTitle = !state.header.showTitle;
    this.setState(state);
  };

  showFeedingInst= (show) => {
    const state = this.state;
    state.header.showFeedingInst = show;
    this.setState(state);
  };

  componentWillMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      const state = this.state;
      if(location.pathname !== `${process.env.PUBLIC_URL}/dashboard/` && location.pathname !== `${process.env.PUBLIC_URL}/dashboard`){
        state.header.showBackButton = true
        state.showFooterMenu = true
      }
      else{
        state.header.showBackButton = false
        state.showFooterMenu = false
      }
      if(location.pathname === `${process.env.PUBLIC_URL}/dashboard/growth-chart/`){
        state.header.showCardSwitcher = true
        state.footer.c_button = 'active'
      }
      else{
        state.header.showCardSwitcher = false
        state.footer.c_button = ''
      }
      if(location.pathname === `${process.env.PUBLIC_URL}/dashboard/feeding/feeding-practice/`){
        state.header.showTitle = false;
      }
      else{
        state.header.showTitle = true;
      }
      if(location.pathname === `${process.env.PUBLIC_URL}/dashboard/past-advice/` || location.pathname === `${process.env.PUBLIC_URL}/dashboard/feeding/` ||
        location.pathname === `${process.env.PUBLIC_URL}/dashboard/feeding/feeding-practice/` || location.pathname === `${process.env.PUBLIC_URL}/dashboard/feeding/smart-feeding/`){
        state.footer.f_button = 'active'
      }
      else{
        state.footer.f_button = ''
      }
      if(location.pathname === `${process.env.PUBLIC_URL}/dashboard/contact-us/`){
        state.footer.co_button = 'active'
      }
      else{
        state.footer.co_button = ''
      }
      if(location.pathname === `${process.env.PUBLIC_URL}/dashboard/faqs/`){
        state.footer.fa_button = 'active'
      }
      else{
        state.footer.fa_button = ''
      }

      this.setState(state);

    });
  }

  logout = () => {
    const state = this.state;
    UserController.logout();
    // .then((res) => {
      // if(res){
        state.logedin = false;
        state.checked = true;
        this.setState(state);
    //   }
    //   else{
    //     this.setState({logedin: true, checked: true});
    //     alert("not set");
    //   }
    // }).catch((error) => {
    //     alert(error);
    // });
  }

  login = () => {
    this.props.history.push(`${process.env.PUBLIC_URL}/login/`);
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    if(window.location.pathname !== `${process.env.PUBLIC_URL}/` )
      this.getData();
  }

  render() {
    const { loading, success } = this.state.response;
    const { header, footer, logedin, checked } = this.state;
    // const loginCheck = !logedin ? this.login() : null;
    return (
      <div>
        <Switch>
          <Route exact path={`${process.env.PUBLIC_URL}/`}>
            {/* <AppInstaller /> */}
            <Login />
          </Route>
          <Route exact path={`${process.env.PUBLIC_URL}/login`}>
            <Login />
          </Route>
          <Route path={`${process.env.PUBLIC_URL}/dashboard`}>
          {logedin ? (
          <div className="app-container col-sm-12 col-md-12 col-12" style={{padding: "0px"}}>
          <div className = "app-header">
            <Header Translator= {Translator[this.state.lang]} header = {header} language_list = {Language} onLangChange = {this.onLanguageChange} onCardChange = {this.onCardChange} showSideBar = {this.showSideBar} />
          </div>
            
          <div className = "app-main">
            <Switch>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard`}>
              {loading ? (<div>Wait...</div>) : (<Container Translator= {Translator[this.state.lang]} />)}
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/bmi`}>
                <BmiForm Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/feeding`}>
                <Feeding Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/feeding/feeding-practice`}>
                <FeedingForm showFeedingInst= {this.showFeedingInst} showTitle= {this.showTitle} Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/feeding/smart-feeding`}>
                <SmartFeedingForm Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/contact-us`}>
                <ContactUs Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/faqs`}>
                {this.state.lang === "sw" ?
                  <FaqsSwahili Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
                :
                  <Faqs Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
                }
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/past-advice/`}>
                <ReactCalender Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/growth-chart`}>
                <GrowthChart Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} card = {this.state.card} />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/change-password`}>
                <PasswordChanger Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
              </Route>
              <Route exact path={`${process.env.PUBLIC_URL}/dashboard/change-photo`}>
                <PhotoChanger onPhotoChange = {this.onUserPhotoChange} Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
              </Route>
            </Switch>
          </div>
          {this.state.showFooterMenu ? (
          // <div className = "app-footer">
            <FooterMenu footer = {footer} Translator= {Translator[this.state.lang]} />
          // </div>
          ) : (
            <div className = "app-footer">
              <Footer/>
            </div>
          )}
          {this.state.showInfoBar ? (
            <div style = {{zIndex: "1024"}}>
              <SideBar showSideBar = {this.showSideBar} logout = {this.logout} photo = {this.state.User.photo} Translator= {Translator[this.state.lang]} User= {this.state.User} Child = {this.state.Child} age={this.state.age} />
            </div>
          ) : null}
        </div>
        ) : !checked ? (<div>Wait...</div>) : this.login}

          </Route>
        </Switch>
      </div>
    );
  }
}

export const Dashboard = withRouter(Account)
export default withRouter(Account);
